var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2,
    width: 22,
    height: 20,
    rx: 5,
    fill: "none",
    className: "fill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_11724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2616 7.4221L18.2954 7.4221C18.5063 7.4221 18.6793 7.59509 18.6793 7.80606L18.6793 13.8061L19.9156 12.5698C20.0633 12.4221 20.308 12.4221 20.4557 12.5698L21.8861 14.0086C22.0338 14.1563 22.0338 14.401 21.8861 14.5487L17.5485 18.8905C17.4051 19.0339 17.1519 19.0339 17.0084 18.8905L12.6667 14.5487C12.519 14.401 12.519 14.1563 12.6667 14.0086L14.1055 12.574C14.2532 12.4263 14.4979 12.4263 14.6456 12.574L15.8819 13.8103L15.8819 7.80606C15.8819 7.59509 16.0549 7.4221 16.2658 7.4221L16.2616 7.4221ZM17.9114 8.19003L16.6456 8.19003L16.6456 14.7301C16.6456 14.8862 16.5527 15.0255 16.4093 15.0845C16.2658 15.1436 16.1013 15.1099 15.9916 15.0002L14.3755 13.3841L13.481 14.2786L17.2743 18.0803L21.0759 14.2786L20.1814 13.3841L18.5654 15.0002C18.4557 15.1099 18.2911 15.1436 18.1477 15.0845C18.0042 15.0255 17.9114 14.8862 17.9114 14.7301L17.9114 8.18581L17.9114 8.19003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70886 7.4221L7.74262 7.4221C7.95359 7.4221 8.12658 7.59509 8.12658 7.80606L8.12658 13.8061L9.36287 12.5698C9.51055 12.4221 9.75527 12.4221 9.90295 12.5698L11.3418 14.0044C11.4895 14.1521 11.4895 14.3968 11.3418 14.5445L6.99578 18.8905C6.85232 19.0339 6.59915 19.0339 6.4557 18.8905L2.11392 14.5487C1.96624 14.401 1.96624 14.1563 2.11392 14.0086L3.54852 12.574C3.6962 12.4263 3.94093 12.4263 4.08861 12.574L5.32489 13.8103L5.32489 7.80606C5.32489 7.59509 5.49789 7.4221 5.70886 7.4221ZM7.35865 8.19003L6.09283 8.19003L6.09283 14.7301C6.09283 14.8862 6 15.0255 5.85654 15.0845C5.71308 15.1436 5.54852 15.1099 5.43882 15.0002L3.82278 13.3841L2.92827 14.2786L6.72574 18.0803L10.5232 14.2829L9.62869 13.3883L8.01266 15.0044C7.90295 15.1141 7.7384 15.1478 7.59494 15.0888C7.45148 15.0297 7.35865 14.8905 7.35865 14.7343L7.35865 8.19003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38397 5.06312L21.616 5.06312C21.827 5.06312 22 5.23612 22 5.44709C22 5.65806 21.827 5.83105 21.616 5.83105L2.38397 5.83105C2.17299 5.83105 2 5.65806 2 5.44709C2 5.23612 2.17299 5.06312 2.38397 5.06312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_11724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.9367,
    fill: "white",
    transform: "translate(22 19) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchase-order.1cfe1156.svg";
export { ForwardRef as ReactComponent };